import React, { useRef } from 'react';
import { Question } from '../../../utils/types/assessment_types';
import { Button } from '../../components';
import { CloseIcon } from '../../icons/icons';
import { SecondaryTypography } from '../../typography/typography';
import styles from './upload_media.module.css';

type UploadMediaProps = {
  question: Question;
  addFileViaInput: (event: React.ChangeEvent<HTMLInputElement>) => void;
  clearMediaFile: () => void;
};

export const UploadMedia = ({
  question,
  addFileViaInput,
  clearMediaFile,
}: UploadMediaProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const checkMediaType = () => {
    return !question.mediaExtension?.match(/^(mp4|mkv|avi|webm)$/);
  };

  const renderMediaInput = () => {
    if (question.mediaQuestion) {
      return (
        <div className={styles.mediaPreviewContainer}>
          <SecondaryTypography.XSmall
              className={styles.textClass}
              fontWeight='semi-bold'
          >
            Attached Media File
          </SecondaryTypography.XSmall>
          <div className={styles.imageVideoContainer}>
            { checkMediaType() ? (
              <img
                  width='500px'
                  src={question.fileEncoded || question.fileUrl}
                  alt={question.id + 'Media'}
              />
            ) : (
              <video
                  width='500px'
                  controls
                  src={question.fileEncoded || question.fileUrl}
              />
            ) }
            <div className={styles.iconClass} onClick={clearMediaFile}>
              <CloseIcon />
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className='flex flex-col gap-1.5 sm:flex-row sm:items-center sm:gap-2'>
          <Button
              onClick={() => fileInputRef.current?.click()}
              variant='primary'
              label='Upload Media'
              type='button'
              className='min-h-9 w-full px-3 py-1.5 text-sm sm:w-44'
          />
          <SecondaryTypography.XSmall
              className={`${styles.textClass} leading-4 text-slate-500`}
              fontWeight='semi-bold'
          >
            File types supported: mp4, mkv, avi, webm, jpg, jpeg, png, gif. Max
            Size: 20MB
          </SecondaryTypography.XSmall>
        </div>
      );
    }
  };

  return (
    <>
      <input
          type='file'
          onChange={addFileViaInput}
          ref={fileInputRef}
          style={{ display: 'none' }}
      />
      { renderMediaInput() }
    </>
  );
};
